'use strict';

export function isValidPhrase(value) {
  var minimumValue = 2;
  return value && value.trim().length >= minimumValue;
}

export const keys = { tab:9, enter: 13, up: 38, down: 40, escape: 27, space: 32, left: 37, right: 39, home: 36, end: 35  };
